export default __webpack_public_path__ + "static/media/discourage user2.4fd02f3a.jpg";